import { cn } from '@/lib/utils';
import { Loader2 } from 'lucide-react';

interface SpinnerProps extends React.HTMLAttributes<HTMLDivElement> {
  size?: 'sm' | 'md' | 'lg';
  variant?: 'default' | 'primary';
}

const sizeClasses = {
  sm: 'h-4 w-4',
  md: 'h-6 w-6',
  lg: 'h-8 w-8',
};

export function Spinner({ size = 'md', variant = 'default', className, ...props }: SpinnerProps) {
  return (
    <div role="status" {...props}>
      <Loader2
        className={cn(
          'animate-spin',
          sizeClasses[size],
          variant === 'primary' ? 'text-primary' : 'text-muted-foreground',
          className
        )}
      />
      <span className="sr-only">Loading...</span>
    </div>
  );
}

interface PageSpinnerProps {
  message?: string;
}

export function PageSpinner({ message = 'Loading...' }: PageSpinnerProps) {
  return (
    <div className="flex flex-col items-center justify-center min-h-[400px] gap-4">
      <Spinner size="lg" variant="primary" />
      <p className="text-sm text-muted-foreground">{message}</p>
    </div>
  );
}

interface OverlaySpinnerProps {
  isVisible: boolean;
  message?: string;
}

export function OverlaySpinner({ isVisible, message }: OverlaySpinnerProps) {
  if (!isVisible) return null;

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-background/80 backdrop-blur-sm">
      <div className="flex flex-col items-center gap-4">
        <Spinner size="lg" variant="primary" />
        {message && <p className="text-sm text-muted-foreground">{message}</p>}
      </div>
    </div>
  );
}
